import i18n from "i18n";

// siteUrl should be '/key', where key is the key of the location in the locations object
// this is because MainPage bases on the location param to render the correct location

export const getLocations = () => {
  return {
    wroclaw: {
      title: "WROCŁAW",

      // site data
      siteUrl: "/wroclaw",
      siteTitle: "Pixel XL Wroclaw",
      googleMapsOptions: {
        latitude: 51.10697301550853,
        longitude: 17.03222937059691,
        zoom: 15,
      },
      prices: {
        smallGroupLowerPrice: "35",
        smallGroupHigherPrice: "50",
        bigGroupLowerPrice: "30",
        bigGroupHigherPrice: "45",
        arenaLowerPrice: "20",
        arenaHigherPrice: "30",
      },
      aboutUsImages: [
        "/images/wroclaw/about-us/about-picture-1.jpg",
        "/images/wroclaw/about-us/about-picture-2.jpg",
        "/images/wroclaw/about-us/about-picture-3.jpg",
        "/images/wroclaw/about-us/about-picture-4.v2.jpg",
        "/images/wroclaw/about-us/about-picture-5.jpg",
        "/images/wroclaw/about-us/about-picture-6.jpg",
      ],
      aboutUsMobileImages: [
        "/images/wroclaw/about-us/mobile-about-picture-1.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-3.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-4.v2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-5.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-6.jpg",
      ],
      documents: {
        pl: {
          companies: "/documents/wroclaw/companies.pdf",
          schools: "/documents/wroclaw/schools.v4.pdf",
          birthdays: "/documents/wroclaw/birthdays.v3.pdf",
        },
        eng: {
          companies: "/documents/wroclaw/companies-eng.pdf",
          schools: "/documents/wroclaw/schools-eng.pdf",
          birthdays: "/documents/wroclaw/birthdays-eng.pdf",
        },
      },
      address: "Świdnicka 12, 50-068 Wrocław",
    },
    katowice: {
      title: "KATOWICE",
      label: i18n.t("locationsPage.comingSoon"),

      // site data
      siteUrl: "/katowice",
      siteTitle: "Pixel XL Katowice",
      googleMapsOptions: {
        latitude: 51.10697301550853,
        longitude: 17.03222937059691,
        zoom: 15,
      },
      prices: {
        smallGroupLowerPrice: "35",
        smallGroupHigherPrice: "50",
        bigGroupLowerPrice: "30",
        bigGroupHigherPrice: "45",
        arenaLowerPrice: "25",
        arenaHigherPrice: "35",
      },
      aboutUsImages: [
        "/images/wroclaw/about-us/about-picture-1.jpg",
        "/images/wroclaw/about-us/about-picture-2.jpg",
        "/images/wroclaw/about-us/about-picture-3.jpg",
        "/images/wroclaw/about-us/about-picture-4.jpg",
        "/images/wroclaw/about-us/about-picture-5.jpg",
        "/images/wroclaw/about-us/about-picture-6.jpg",
      ],
      aboutUsMobileImages: [
        "/images/wroclaw/about-us/mobile-about-picture-1.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-2.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-3.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-4.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-5.jpg",
        "/images/wroclaw/about-us/mobile-about-picture-6.jpg",
      ],
      documents: {
        pl: {
          companies: "/documents/wroclaw/companies.pdf",
          schools: "/documents/wroclaw/schools.v4.pdf",
          birthdays: "/documents/wroclaw/birthdays.v3.pdf",
        },
        eng: {
          companies: "/documents/wroclaw/companies-eng.pdf",
          schools: "/documents/wroclaw/schools-eng.pdf",
          birthdays: "/documents/wroclaw/birthdays-eng.pdf",
        },
      },
      address: "Świdnicka 12, 50-068 Wrocław",
    },
  };
};
